export default __webpack_public_path__ + "static/heroSectionImg-45ee1b2d6b9ab7e5f31590985a007504.webp";